'use strict';

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});

exports.createHtmlRenderState = createHtmlRenderState;
//# sourceMappingURL=create-render-state.cjs.map
